// extracted by mini-css-extract-plugin
export default {"form-search":"Category_form-search__inxZm","btn-add":"Category_btn-add__Aqpk3"};